module.exports = __webpack_public_path__ + "static/latitude-infinity-e34f502856d404afa2c745cbb65e8adb.png";